{
  "title": "Edit collaborator",
  "subtitle": "Update collaborator information.",
  "form": {
    "personalInfo": "Personal information",
    "lastname": "Last name",
    "firstname": "First name"
  },
  "placeholders": {
    "lastname": "Last name",
    "firstname": "First name"
  },
  "buttons": {
    "validate": "Validate"
  },
  "messages": {
    "success": "Collaborator updated"
  }
}
